import React from "react";
import { Helmet } from "react-helmet";
import HeroSection from "./HeroSection";
import ProductGrid from "./ProductGrid";
import FarmersSection from "./FarmersSection";
import Footer from "../../components/common/Footer";
import TestimonialPage from "./FarmersSection";

const ProductCatalog = () => {
  return (
    <>
      <Helmet>
        <title>
          Premium Organic Fertilizers | Kesari Phos, Organic Manure & Garden
          Nest | Utpann
        </title>
        <meta
          name="description"
          content="Explore Utpann's complete product catalog featuring premium organic fertilizers - Kesari Phos, Fermented Organic Manure, and Garden Nest. Trusted by farmers nationwide for sustainable agriculture solutions."
        />
        <meta
          property="og:title"
          content="Premium Organic Fertilizers | Kesari Phos, Organic Manure & Garden Nest | Utpann"
        />
        <meta
          property="og:description"
          content="Explore Utpann's complete product catalog featuring premium organic fertilizers - Kesari Phos, Fermented Organic Manure, and Garden Nest. Trusted by farmers nationwide for sustainable agriculture solutions."
        />
      </Helmet>

      <main>
        <HeroSection />
        <ProductGrid />
        <TestimonialPage />
        <Footer />
      </main>
    </>
  );
};

export default ProductCatalog;
